export default __webpack_public_path__ + "static/media/35.d2f9101b.png";